<template>
    <div class="">
        <md-dialog :md-active.sync="modalModAutomatica" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }} {{ infoContrato.nro_contrato }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoContrato }}</pre> -->
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.fechaInicial}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="fechaInicial" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.fechaFinal}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left align-self-end">
                        <h6>{{formatearFecha(infoContrato.fecha_final)}}</h6>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.cambioCanon}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="cambioCanon" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipTasa in listTipoTasa" :key="tipTasa.id" :value="tipTasa.tipo_tasa">{{ tipTasa.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tasa}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="tasaCambioCanon" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.frecuencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="frecuenciaCambioCanon" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option value="30">30</option>
                            <option value="60">60</option>
                            <option value="90">90</option>
                            <option value="180">180</option>
                            <option value="360">360</option>
                        </select>
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="3">
                        <md-button class="md-primary" @click="saveModAutomatica">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoTasa from '../../services/TipoTasas'
import ContratoCuota from '../../services/ContratoCuota'
export default {
    name:'ModificacionAutomatica',
    props:['modalModAutomatica','infoContrato'],
    data:() => ({
        fechaInicial : '',
        tasaCambioCanon : '',
        frecuenciaCambioCanon : '',
        cambioCanon : '',
        listTipoTasa : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Contrato No.',
                    save : 'Guardar',
                    close : 'Cerrar',
                    cambioCanon : 'Cambio canon',
                    fechaInicial : 'Fecha inicial',
                    fechaFinal : 'Fecha final',
                    tasa : 'Tasa',
                    frecuencia : 'Frecuencia',
                    select : 'Seleccione...'
                }
            }else{
                return {
                    title : 'Contract No.',
                    save : 'Save',
                    close : 'Close',
                    cambioCanon : 'Canon change',
                    fechaInicial : 'Starting date',
                    fechaFinal : 'EndDate',
                    tasa : 'Rate',
                    frecuencia : 'Frequency',
                    select : 'Select...'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        saveModAutomatica(){
            let datosForm = [
                this.fechaInicial,
                this.cambioCanon,
                this.tasaCambioCanon,
                this.frecuenciaCambioCanon,
            ]

            if(datosForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                const fechaInicio = new Date(this.fechaInicial);
                const fechaFin = new Date(this.infoContrato.fecha_final);

                const diferenciaEnMeses = (fechaFin.getFullYear() - fechaInicio.getFullYear()) * 12 + fechaFin.getMonth() - fechaInicio.getMonth();

                let datos = {
                    'nro_contrato' : this.infoContrato.nro_contrato,
                    'arrendador' : this.infoContrato.identificacion,
                    'tipoContrato' : this.infoContrato.tipo_contrato,
                    'tipoActivo' : this.infoContrato.tipo_activo,
                    'frecuencia' : this.infoContrato.frecuencia,
                    'modalidad' : this.infoContrato.modalidad,
                    'tipoTasa' : this.infoContrato.tipo_tasa,
                    'tasa' : this.infoContrato.tasa,
                    'canonArrendamiento' : Number(this.infoContrato.canon_arrendamiento),
                    'valContrato' : Number(this.infoContrato.valor_contrato),
                    'fechaInicial' : this.fechaInicial,
                    'fechaFinal' : this.infoContrato.fecha_final,
                    'cambioCanon' : this.cambioCanon,
                    'tasaCambioCanon' : this.tasaCambioCanon,
                    'frecuenciaCambioCanon' : this.frecuenciaCambioCanon,
                    // 'listActivosSel' : this.infoContrato.activosSelected,
                    'cantidadCuotas' : diferenciaEnMeses,
                    'idUser' : this.$store.state.userId
                }

                // console.log(datos);
                ContratoCuota.createContratoCuota(datos)
                .then((res) => {
                    console.log(res.data);
                })
                .catch((err) => {
                    console.log(err);
                })
            }
        },
        formatearFecha(fecha) {
            // let newFecha = new Date(fecha)
            // const dia = String(newFecha.getDate()).padStart(2, '0');
            // const mes = String(newFecha.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
            // const anio = newFecha.getFullYear();

            // return `${dia}/${mes}/${anio}`;
            return fecha
        }
    },
    mounted(){
        TipoTasa.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => console.log(err))
    }
}
</script>